import { useEffect } from "react";
import { datadogRum } from "@datadog/browser-rum";

export const DataDogRUM = () => {
  useEffect(() => {
    datadogRum.init({
      applicationId: "886ddfab-d681-4475-89de-30d1f5c04831",
      clientToken: "pub10536218d0da686ff832428a61ff4c56",
      site: "datadoghq.com",
      service: process.env.NEXT_PUBLIC_PACKAGE,
      env: process.env.NEXT_PUBLIC_ENV_NAME,
      sampleRate: Number(process.env.NEXT_PUBLIC_DD_RUM_SAMPLE_RATE) || 0,
      premiumSampleRate:
        Number(process.env.NEXT_PUBLIC_DD_RUM_PREMIUM_SAMPLE_RATE) || 0,
      trackUserInteractions: true,
      defaultPrivacyLevel: "mask-user-input",
      trackSessionAcrossSubdomains: true,
      enableExperimentalFeatures: ["clickmap"],
      trackFrustrations: true,
      trackLongTasks: true,
    });

    datadogRum.startSessionReplayRecording();
  });
  return null;
};
